export const model3dOutputGlobalId = 229;
